export default __webpack_public_path__ + "static/media/expl-gradcam_14_EN.31c2241d.png";